var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Exchange50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA726",
    d: "M20,12c0,3.314-2.687,6-6,6s-6-2.686-6-6c0-3.314,2.686-6,6-6S20,8.686,20,12 M40,12c0-3.314-2.687-6-6-6s-6,2.686-6,6c0,3.314,2.687,6,6,6S40,15.314,40,12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M24,28H4v-3c0,0,2.767-5,10-5c7.232,0,10,5,10,5V28z M44,25c0,0-2.768-5-10-5c-7.233,0-10,5-10,5v3h20V25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M37,42v-4h-8v-4h8v-4l7,6L37,42z M11,30l-7,6l7,6v-4h8v-4h-8V30z M25,38h2v-4h-2V38z M21,38h2v-4h-2V38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Exchange50);
export default __webpack_public_path__ + "static/media/icons8-exchange-50.d1f2162c41d626229efa766088bd5da3.svg";
export { ForwardRef as ReactComponent };